module.exports = __webpack_public_path__ + "img/mile6m-m@2.d73a66f2.jpg";